// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{scroll-behavior:smooth}#root{min-height:100vh}", "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAGA,KAAA,sBAAA,CAEA,MACI,gBAAA","sourcesContent":["@import './styles/globals';\n@import './styles/typography';\n\nhtml { scroll-behavior: smooth;};\n\n#root {\n    min-height: 100vh\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
